/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { Button } from "../../ui/button";
import React, { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { IFullDeviceDetails } from "../../../store/api/deviceConfig/types";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import { useSelector } from "react-redux";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import { Maximize2 } from "lucide-react";
const Iframe = () => {
  const { state } = useLocation();
  const deviceDetail = state.deviceDetail as IFullDeviceDetails;
  const ipAddress = deviceDetail?.ipAddress;
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);

  const iframeRef = useRef<HTMLIFrameElement>(null);

  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    if (ipAddress == null || permissions == null || ipAddress.length === 0) {
      return;
    }

    if (permissions.hasOpCodeGroup("manage_sn")) {
      setAllowed(true);
    }
  }, [ipAddress, permissions]);

  useEffect(() => {
    if (allowed) {
      const win = iframeRef.current!.contentWindow;

      win!.location = "/ssh/login/" + ipAddress.replace(/^\[|\]$/g, "");
    }
  }, [allowed, ipAddress]);

  function openFullScreen() {
    window.open("/ssh/login/" + ipAddress.replace(/^\[|\]$/g, ""), "_blank");
  }
  return allowed ? (
    <>
      <div className="flex items-end justify-end pb-2">
        <Button variant="outline" size="sm" onClick={openFullScreen}>
          Full screen <Maximize2 className="h-4 w-4 ml-1" />
        </Button>
      </div>
      <div className="border border-border rounded-[var(--radius)]">
        <iframe title="iframe" ref={iframeRef} width="100%" height="600" style={{ display: "block", borderRadius: "10px" }} />
      </div>
    </>
  ) : (
    <p>Shell access is not permitted</p>
  );
  /*
    return createPortal(
        <iframe
          title="iframe"
          ref={iframeRef}
        />,
        document.createElement('iframe')
    );
*/
};

export default Iframe;